import React from 'react'
import { GroupingHeaderIconContainer } from './styles'
import { ExpandPanelButtonProps } from './props'
import { useTranslation } from 'react-i18next'
import KeydriveTooltip from '../../KeydriveComponents/Tooltip/KeydriveTooltip'
import { LeftPanelCloseIcon } from '../../../assets/icons/LeftPanelCloseIcon'
import { LeftPanelOpenIcon } from '../../../assets/icons/LeftPanelOpenIcon'

export const ExpandPanelButton: React.FC<ExpandPanelButtonProps> = ({
  open,
  setOpen,
}) => {
  const { t } = useTranslation();

  return (
    <KeydriveTooltip
      title={
        !open
          ? t('View.MinGroups')
          : t('View.MaxGrups')
      }
      start
    >
      <GroupingHeaderIconContainer onClick={() => setOpen(!open)}>
        <div className="hover">
          {!open ? <LeftPanelCloseIcon /> : <LeftPanelOpenIcon />}
        </div>
      </GroupingHeaderIconContainer>
    </KeydriveTooltip>
  )
}
